module.exports = __webpack_public_path__ + "static/contact-image-2_d-ae2ca2823a1481f848d4fbe6c27aa50c.jpg";